import { NgModule } from '@angular/core';

import { AsyncCdkDrag } from './async-cdk-drag.directive';

@NgModule({
  declarations: [AsyncCdkDrag],
  exports: [AsyncCdkDrag],
})
export class AsyncCdkDragModule {}
export { AsyncCdkDrag } from './async-cdk-drag.directive';
